import { createAction, props } from '@ngrx/store';
import { Devis } from '../../models/form-state.model';

export const patchDevis = createAction(
  '[Devis] Patch Devis ',
  props<{ payload: Partial<Devis> }>()
);

export const init = createAction('[Init]');
